import {
	Decimal
} from 'decimal.js';
import {
	toThousandFilter
} from '@/utils';
import dayjs from 'dayjs';

// 订单状态
export function orderStatus(value) {
	switch (value) {
		case 0:
			return '待确认';
		case 1:
			return '已确认';
		case 2:
			return '已驳回';
		default:
			return '全部订单';
	}
}

// 核销状态
export function writeOffStatus(value) {
	switch (value) {
		case 0:
			return '未核销';
		case 1:
			return '已核销';
		default:
			return '--';
	}
}


// 订单内容
export function orderContent(orderType, order) {
	switch (orderType) {
		case 1: // 峰会
			return order.summitCourseName;
		case 2: // 项目
		case 4:
			return order.projectName;
		case 3: // 师训课
			return order.projectTeacherCourseName;
		default:
			return '--';
	}
}

// 订单类型
export function orderType(orderType) {
	switch (orderType) {
		case 1:
			return '峰会';
		case 2:
			return '项目';
		case 3:
			return '师训课';
		case 4:
			return '普通商品';
		case 5:
			return '峰会师训课'
		default:
			return '--';
	}
}

// 收益类型
export function profitOrderType(orderType) {
	switch (orderType) {
		case 1:
			return '峰会';
		case 2:
			return '项目';
		case 3:
			return '师训课';
		case 4:
			return '底薪';
		case 5:
			return '业绩不达标';
		default:
			return '';
	}
}

// 支付方式
export function payType(payType) {
	switch (payType) {
		case 1:
			return '微信';
		case 2:
			return '支付宝';
		case 3:
			return '现金';
		case 4:
			return 'pos机代刷';
		default:
			return '';
	}
}

// 收益类型
export function profitType(profitType) {
	switch (profitType) {
		case 1:
			return '归属人提成';
		case 2:
			return '成交人提成';
		case 3:
			return '团队业绩提成'
		case 4:
			return '底薪';
		default:
			return '';
	}
}

// 后台返回的金额单位是分，所以需要前端进行转换
export function money(money) {
	if (money) {
		const val = new Decimal(money).div(new Decimal(100)).toDecimalPlaces(2, Decimal.ROUND_UP).toNumber();
		return toThousandFilter(val);
	}
	return 0;
}

// 价格过滤器
export let TXcurrency = (value, prefix = '') => {
	return prefix + (value / 100).toFixed(2)
}

/**
 * 将m转换成km
 * @param {*} val 距离
 */
export function convertMilesToKm(val) {
	if (val >= 1) {
		const km = new Decimal(val).toDecimalPlaces(2, Decimal.ROUND_UP)
		return `${km}km`
	}
	return typeof val === 'number' ? `${new Decimal(val).mul(1000).toDecimalPlaces(2, Decimal.ROUND_UP)}m` : '--'
}

/**
 * 格式化时间戳
 * @param {*} val 时间戳
 * @returns 日期格式YYY-MM-DD HH:mm:ss
 */
export function dateFormat(val) {
	if (!val) return '--'
	return dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss')
}
